const objectPath = require('object-path')
const deepmerge = require('deepmerge')
const timeUtils = require('./time')

const defaultValues = {
  text: '',
  textarea: '',
  radio: '',
  checkbox: false,
  multipleCheckbox: {},
  select: '',
  color: {
    color: ''
  },
  image: null,
  list: [],
  time: timeUtils.getTimeNumberFromTime(timeUtils.getTimeFromDate(new Date())),
  embedWidget: {
    enabled: true,
    days: 3,
    slotsPerDay: 1,
  },
}

const flattenSchema = (schema) => {
  return schema.reduce((all, row) => {
    return row.constructor === Array ?
      all.concat(row) :
      all.concat([row])
  }, [])
}

const getFieldDescription = (field) => {
  if(!field.description) return []
  return field.description instanceof Array ?
        field.description :
        [field.description]
}

const getInitialValues = (schema, actualValues) => {
  const flatSchema = flattenSchema(schema)
  const values = flatSchema.reduce((all, field) => {
    const existing = objectPath.get(actualValues, field.id)
    if(typeof(existing) !== 'undefined') {
      objectPath.set(all, field.id, existing)
    }
    else if(typeof(field.default) !== 'undefined') {
      objectPath.set(all, field.id, field.default)
    }
    else if(field.list) {
      objectPath.set(all, field.id, [])
    }
    else if(typeof(field.component) === 'string' && typeof(defaultValues[field.component]) !== 'undefined') {
      objectPath.set(all, field.id, defaultValues[field.component])
    }
    else {
      objectPath.set(all, field.id, '')
    }
    return all
  }, {})
  return values
}

const getFieldValidation = (field, template) => {
  if(!field.validate) return null
  if(!field.validate.methods) return field.validate
  try {
    const result = Object.assign({}, field.validate, {
      methods: field.validate.methods.map(method => {
        return [method.type].concat(method.args.map(arg => {
          return template ?
            template(arg, `getFieldValidation.${field.id}`) :
            arg
        }))
      })
    })
    return result
  } catch(e) {
    console.error(field)
    throw new Error(`could not reduce field validation for the ${field.id} field`)
  }
  
}

const processOptionsSchemaSections = ({
  config,
}) => config.options
  .reduce((all, item) => {
    return all
      .concat([item.title])
      .concat(item.fields)
  }, [])

const processPlainSchema = (schema) => {
  return schema.map(field => {
    if(!field.validate) return field
    return Object.assign({}, field, {
      validate: getFieldValidation(field),
    })
  })
}

const processSchema = ({
  config,
  slot,
  schema,
  template,
}) => {
  if(!slot) return []
  return schema.map(field => {
    if(typeof(field) === 'string') return field

    if(typeof(field.function) === 'string') {
      field = template(field, `dynamic_field_function`)
    }

    const ret = {
      ...field,
      title: template(field.title, `field.title.${field.id}`),
      helperText: getFieldDescription(field).map(t => template(t, `field.helperText.${field.id}`)),
      validate: getFieldValidation(field, template),
      list_schema: processSchema({
        config,
        slot,
        schema: field.list_schema || [],
        template,
      }),
    }

    if(typeof(field.default) !== 'undefined') {
      ret.default = template(field.default, `field.default.${field.id}`)
    }

    if(typeof(ret.default) === 'undefined') {
      ret.default = ''
    }

    return ret
  })
}

const getOptionsSchema = ({
  config,
  slot,
  template,
}) => {
  if(!config) return []

  // this is not flat schema as in nested arrays
  // but dealing with sections and their fields
  const flatSchema = processOptionsSchemaSections({
    config,
    slot,
  })

  return processSchema({
    config,
    slot,
    schema: flatSchema,
    template,
  })
}

const getDetailsSchema = ({
  config,
  slot,
  template,
}) => {
  if(!config) return []

  return processSchema({
    config,
    slot,
    schema: config.info,
    template,
  })
}

const getDefaultData = ({
  config,
  slot,
  template,
}) => {
  const optionsSchema = getOptionsSchema({config, slot, template})
  const detailsSchema = getDetailsSchema({config, slot, template})
  return {
    options: getInitialValues(optionsSchema, {}),
    details: getInitialValues(detailsSchema, {})
  }
}

const mergeData = (items) => {
  return deepmerge.all(items.filter(i => i), {
    arrayMerge: (_, sourceArray) => sourceArray,
  })
}
const timeRange = (slot) => {
  if(!slot) return null
  if(!slot.start) return null
  if(!slot.duration) return {start: slot.start}
  return timeUtils.getRange(slot.start, slot.duration)
}
const getTimeRangeTitle = (slot) => timeUtils.getRangeTitle(timeRange(slot))
const getSlotPrices = (slot, prices) => {
  return Object.assign({}, prices.default, slot ? prices[slot.price] : {})
}

module.exports = {
  defaultValues,
  flattenSchema,
  getFieldDescription,
  getInitialValues,
  getFieldValidation,
  processOptionsSchemaSections,
  processPlainSchema,
  processSchema,
  getOptionsSchema,
  getDetailsSchema,
  getDefaultData,
  mergeData,
  timeRange,
  getTimeRangeTitle,
  getSlotPrices,
}